import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import HomeMidFunnelAdsRoute from "./mid-funnel-ads";
import HomeOfferListRoute from "./offer-list";
import { PHASE } from "../../routeConfig";
import SelectHomeIssuerRoute from "./select-issuer";
import UnlinkedApplicationHomeownersRoutes from "./unlinked-application";
var HaveHomeLoginRoute = React.lazy(function () { return import(/* webpackChunkName: "HaveHomeLogin" */ "./have-login"); });
var HomeCredentialsRoute = React.lazy(function () { return import(/* webpackChunkName: "HomeCredentials" */ "./credentials"); });
var HomeForgotPasswordRoute = React.lazy(function () {
    return import(/* webpackChunkName: "HomeForgotPassword" */ "./forgot-password");
});
var HomePoliciesLoadingRoute = React.lazy(function () {
    return import(/* webpackChunkName: "HomePoliciesLoading" */ "./policies-loading");
});
var HomePoliciesLoadedRoute = React.lazy(function () {
    return import(/* webpackChunkName: "HomePoliciesLoaded" */ "./policies-loaded");
});
var HomePoliciesMissingData = React.lazy(function () {
    return import(
    /* webpackChunkName: "HomePoliciesMissingData" */ "./policies-missing-data");
});
var HomeUnsupportedIssuerRoute = React.lazy(function () {
    return import(
    /* webpackChunkName: "HomeUnsupportedIssuer" */ "./unsupported-issuer");
});
var HomeUnqualifiedRoute = React.lazy(function () { return import(/* webpackChunkName: "HomeUnqualified" */ "./unqualified"); });
var RememberHomeLoginRoute = React.lazy(function () { return import(/* webpackChunkName: "RememberHomeLogin" */ "./remember-login"); });
export default function HomeRoutes() {
    var path = useRouteMatch().path;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "".concat(path, "/select-issuer") },
            React.createElement(SelectHomeIssuerRoute, null)),
        React.createElement(Route, { path: "".concat(path, "/have-login") },
            React.createElement(HaveHomeLoginRoute, null)),
        React.createElement(Route, { path: "".concat(path, "/remember-login") },
            React.createElement(RememberHomeLoginRoute, null)),
        React.createElement(Route, { path: PHASE.HOME_UNSUPPORTED, component: HomeUnsupportedIssuerRoute }),
        React.createElement(Route, { path: PHASE.HOME_UNQUALIFIED, component: HomeUnqualifiedRoute }),
        React.createElement(Route, { path: PHASE.HOME_ENTER_CREDENTIALS },
            React.createElement(HomeCredentialsRoute, null)),
        React.createElement(Route, { path: PHASE.HOME_POLICIES_LOADING },
            React.createElement(HomePoliciesLoadingRoute, null)),
        React.createElement(Route, { path: PHASE.HOME_POLICIES_LOADED },
            React.createElement(HomePoliciesLoadedRoute, null)),
        React.createElement(Route, { path: PHASE.HOME_POLICIES_MISSING_DATA },
            React.createElement(HomePoliciesMissingData, null)),
        React.createElement(Route, { path: PHASE.HOME_FORGOT_PASSWORD },
            React.createElement(HomeForgotPasswordRoute, null)),
        React.createElement(Route, { path: "".concat(path, "/unlinked-application") },
            React.createElement(UnlinkedApplicationHomeownersRoutes, null)),
        React.createElement(Route, { path: PHASE.HOME_OFFER_LIST },
            React.createElement(HomeOfferListRoute, null)),
        React.createElement(Route, { path: PHASE.HOME_MID_FUNNEL_ADS },
            React.createElement(HomeMidFunnelAdsRoute, null))));
}
